import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './main.css';
import './pages/globals.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
const isDev = import.meta.env && import.meta.env.DEV;
const app = isDev ? <App /> : (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
root.render(app);
